import { TtdTaxonomyElement } from '../services/destinations-api.service';
import { CustomSelectOption } from '../components/shared/custom-select/custom-select.component';

interface TaxonomyNodeTree {
  element: TtdTaxonomyElement;
  children: TaxonomyNodeTree[];
}

/**
 * Flattens a TTD taxonomy element list into an indented option list for a parent-node picker.
 * Only `Buyable=false` rows are nodes (valid parents) — segments (`Buyable=true`) are dropped.
 * Depth-first, parent-grouped order (not plain alphabetical) so indentation reads as a tree.
 */
export function buildTtdParentOptions(elements: TtdTaxonomyElement[]): CustomSelectOption[] {
  const nodes = elements.filter(el => !el.Buyable);
  const byId = new Map<string, TaxonomyNodeTree>();
  nodes.forEach(el => byId.set(el.ProviderElementId, { element: el, children: [] }));

  const roots: TaxonomyNodeTree[] = [];
  byId.forEach(tree => {
    const parent = tree.element.ParentElementId ? byId.get(tree.element.ParentElementId) : undefined;
    if (parent) {
      parent.children.push(tree);
    } else {
      roots.push(tree);
    }
  });

  const sortRecursive = (list: TaxonomyNodeTree[]): void => {
    list.sort((a, b) => a.element.DisplayName.localeCompare(b.element.DisplayName));
    list.forEach(t => sortRecursive(t.children));
  };
  sortRecursive(roots);

  const options: CustomSelectOption[] = [];
  const walk = (list: TaxonomyNodeTree[], depth: number): void => {
    list.forEach(t => {
      options.push({ value: t.element.ProviderElementId, label: `${'— '.repeat(depth)}${t.element.DisplayName}` });
      walk(t.children, depth + 1);
    });
  };
  walk(roots, 0);

  return options;
}
